import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrophy,
  faUsers,
  faFistRaised,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import Button from "../common/Button";

const Features = ({ handleGetStarted }) => {
  const features = [
    {
      icon: faTrophy,
      title: "Global Competition",
      description:
        "Test your skills against the world. Climb the ranks and prove you're the ultimate MMA analyst.",
      color: "bg-deep-red",
    },
    {
      icon: faUsers,
      title: "Private Leagues",
      description:
        "Create private leagues to compete with friends and family. Customize settings and invite members.",
      color: "bg-gold",
    },
    {
      icon: faFistRaised,
      title: "Fighter Lineups",
      description:
        "Build your perfect lineup from upcoming UFC events. Select fighters strategically to maximize points.",
      color: "bg-deep-red",
    },
  ];

  return (
    <section id="features" className="py-16 md:py-24 bg-light-grey">
      <div className="container mx-auto px-4 sm:px-6 max-w-6xl">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-dark-grey">
            Everything You Need For
            <span className="block text-deep-red">Fantasy MMA</span>
          </h2>
          <p className="text-medium-grey text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed">
            A complete fantasy MMA experience with all the tools you need to
            dominate your leagues.
          </p>
        </div>

        {/* Features grid - 3 columns only */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 text-center"
            >
              <div
                className={`w-16 h-16 ${feature.color} rounded-xl flex items-center justify-center mx-auto mb-6`}
              >
                <FontAwesomeIcon
                  icon={feature.icon}
                  className="text-white text-2xl"
                />
              </div>
              <h3 className="text-xl font-bold text-dark-grey mb-4">
                {feature.title}
              </h3>
              <p className="text-medium-grey leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Single Bottom CTA */}
        <div className="text-center">
          <Button
            onClick={handleGetStarted}
            variant="primary"
            size="lg"
            icon={faArrowRight}
            iconPosition="right"
            className="shadow-xl"
          >
            Join Now
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Features;
